import { Theme } from '@mui/material';

export default {
  components: {
    styleOverrides: {
      grouped: ({ theme }: { theme: Theme }) => ({
        margin: theme.spacing(0.5),
        border: 0,
        '&.Mui-disabled': {
          border: 0
        },
        '&:not(:first-of-type)': {
          borderRadius: '8px'
        },
        '&:first-of-type': {
          borderRadius: '8px'
        }
      })
    }
  }
};
